<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">wh11介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                文华财经在量化交易技术方面又一个创新实践，试图把多因子量化方法和商品定价理论做一个融合，用各个商品的产业大数据、市场情绪数据、宏观经济数据等，量化各类市场参与者的决策依据，仿真市场价格的形成机制，对各个商品做多因子定价量化研究。
            </p>
            <p class="intent">
                wh11也内置了文华的AI语言模型技术，支持用文华的行业新闻数据库，用AI技术做行情分析，撰写研究报告。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">11E套餐</p>
            <p>开源因子库：提供包含供给、需求等多维度的444个开源因子；<br>
                定价因子分析：用独创算法对定价因子打分；标尺化数据，统一分析维度，让定价因素可比；<br>
                定价策略研究：以宏观、需求、库存、价差各维度的价格影响因素构建平衡表，借定价因子对价格的影响仿真商品价格形成过程，探寻价格变动依据；<br>
                可视化的产业数据：以图表展示品种的产业数据，通过时序图和季节性分析图展示供应端、需求端、库存、基差等数据结构；<br>
                Python、Excel插件：通过插件工具可对系统数据库中的产业数据、宏观经济数据、期货行情做导出分析或者二次加工，生成报告、可视化分析；<br>
                自有数据落库：支持用户数据落库，在软件中分析维护，与系统库联合构建定价因子和策略。
                </p>
            <a target="_blank" href="https://wh11.wenhua.com.cn/#/Buy">>>> 查看11E套餐更多功能</a>
            <!-- <br>
            <br>
            <p class="detail_title">量化投研</p>
            <p class="tent">量化编写平台：python语言平台，配合文华数据库，编写自由，数据丰富，云计算技术保证运算速度，提高研发效率。</p>
            <p class="tent">文华精选因子库：包含了基本面、市场交易和情绪3个大类14个子类的400多个精选因子。覆盖了当前量化领域的常见因子并持续更新。</p>
            <p class="tent">多因子策略：实现因子库和量化投资方法的融合，提供高效灵活的图表化多因子量化投研、组合优化管理和归因分析。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wh11.wenhua.com.cn/#/Download" target="_blank">wh11</a>体验版了解功能。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用wh11的电脑配置要求：<br />
                · X86架构的CPU，4核及以上配置；<br />
                · windows10、windows11等64位操作系统；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 350px;
}
.details_gn p.tent {
    
}
</style>